var impressum = "インプレスム (所有者情報)";
var privacy = "プライバシー&利用規約";
var recallInfo = "リコール情報";
var signOut = "サインアウト";
var ja_jp = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { ja_jp as default, impressum, privacy, recallInfo, signOut };
